import { render, staticRenderFns } from "./InstitutionalReport.vue?vue&type=template&id=d2ccead8&"
import script from "./InstitutionalReport.vue?vue&type=script&lang=js&"
export * from "./InstitutionalReport.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionalReport.vue?vue&type=style&index=0&id=d2ccead8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports